import { useState } from "react";
import "../../../Styles/SmartLinks/SmartLinks.css";
import isotipoImg from "../../../img/isotipo.png";
import NavBarPeiix from "../../NavBar.jsx";


import { useSmartlinksBl } from "../hooks/useSmartLinksBl.js";
import { useSmartLinks } from "../hooks/useSmartLinks.js"; 


import { SmartLinksFormBl } from "../components/SmartLinksFormBl.jsx"; 
import { SmartLinksForm } from "../components/SmartLinksForm.jsx";
import { LimitErrorModal } from "../components/LimitErrorModal.jsx";

export default function SmartLinksPage() {

  const [provider, setProvider] = useState(() => localStorage.getItem("provider") || "blumon");


  const hookBlumon = useSmartlinksBl();
  const hookKushki = useSmartLinks();

  const isBlumon = provider.toLowerCase() === "blumon";


  const activeHookProps = isBlumon ? hookBlumon : hookKushki;
  return (
    <>
      <NavBarPeiix />
      <div className="smart-links-page">
        <div className="container-wrapper">
          
          <div className="flex justify-between items-center mb-4">
            <p className="fw-bold h2">
              <i className="bi bi-pencil-square"></i> Crear SmartLink
            </p>  
          
          </div>

          {/* Renderizado Condicional del Formulario "Depende el provider" */}
          {provider === "Blumon" ? (
            <SmartLinksFormBl {...activeHookProps} isotipoImg={isotipoImg} />
          ) : (
            <SmartLinksForm {...activeHookProps} isotipoImg={isotipoImg} />
          )}

          <LimitErrorModal
            show={!!activeHookProps.limitModalError}
            message={activeHookProps.limitModalError}
            onClose={activeHookProps.closeLimitModal}
          />

        </div>
      </div>
    </>
  );
}